import googleMapLoader from 'google-map-react/lib/loaders/google_map_loader';
import { Sdk, AutocompleteService } from 'ha/types/GoogleMaps';

interface Config {
  key: string;
  language: string;
}

export default ({ key, language }: Config) => {
  let autocompleteService: Promise<AutocompleteService>;

  function createAutocompleteService() {
    const initializer = googleMapLoader({
      key,
      language,
      libraries: 'places',
    });

    return initializer.then((sdk: Sdk) => {
      return new sdk.places.AutocompleteService();
    });
  }
  return {
    init: () => {
      if (!autocompleteService) {
        autocompleteService = createAutocompleteService();
      }

      return autocompleteService;
    },
  };
};
